<template>
<div>
            <div class="welcomeContainer">
            <div class="welcomeHeader headerText">{{ data.text }}</div>
            <div class="welcomeContent">{{ data.content }}</div>
          </div>
          </div>
</template>

<script>
import "../scss/welcome-content.css";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
    methods: {
      runFirstLoad(){
        
      }
    }
}
</script>

<style>

</style>